export const getDefaultRoles = (
  companyId: string,
  companyName: string,
  hasClientAdmin: boolean = false
) => {
  const roles = [
    {
      role_name: 'admin',
      role: 100,
      display_name: 'Admin',
      company_id: companyId,
      company_name: companyName,
      modules:
        'VIDEOS,ADMIN,USER,PROFILE,PROJECT STATUS,PHASES,PLOTS,PROJECTS,ROLES,GREETINGS,NEWS,REQUESTS,PAYMENTS,VEHICLE SITEVISITS',
    },
    {
      role_name: 'pro',
      role: 100001,
      display_name: 'Pro',
      company_id: companyId,
      company_name: companyName,
      modules: 'VIDEOS,PROFILE,GREETINGS,NEWS',
    },
    {
      role_name: 'company',
      role: 101,
      display_name: 'Company',
      company_id: companyId,
      company_name: companyName,
      modules:
        'VIDEOS,PROFILE,PLOTS,GREETINGS,NEWS,LEADS,FOLLOWUP,NOTES,SITEVISITS,CUSTOMER SITEVISITS,REMINDERS,PAYMENTS',
    },
    {
      role_name: 'accounts',
      role: 10001,
      display_name: 'Accounts',
      company_id: companyId,
      company_name: companyName,
      modules: 'ACCOUNTS,PROFILE,NEWS,REPORTS',
    },
  ];

  if (hasClientAdmin) {
    roles.push({
      role_name: 'clientadmin',
      role: 10002,
      display_name: 'Client Admin',
      company_id: companyId,
      company_name: companyName,
      modules:
        'VIDEOS,ADMIN,USER,PROFILE,PROJECT STATUS,PHASES,PLOTS,PROJECTS,ROLES,GREETINGS,NEWS,REQUESTS,PAYMENTS,VEHICLE SITEVISITS,ACCOUNTS,REPORTS,PLOT MANAGER,CLIENT ADMIN',
    });
  }

  return roles;
};

export const getDefaultUser = (
  companyId: string,
  companyName: string,
  userId: string,
  roleId: string
) => {
  const currentDate = new Date();
  const dateOfBirth = new Date(
    currentDate.getFullYear() - 19,
    currentDate.getMonth(),
    currentDate.getDate()
  );
  return {
    username: 'company',
    first_name: 'company',
    last_name: 'company',
    gender: 'male',
    img: '1709197660415-profile.png',
    dob: dateOfBirth, // Any date above 18 years
    phone: '0000000000',
    email: 'noreply@brandwar.in',
    password: 'brandwar',
    important_dates: new Date(),
    aadhaar_card: JSON.stringify({
      userFrontAadhaar: '1649705754295-images.jpeg',
      userBackAadhaar: '1649705754295-images.jpeg',
    }),

    aadhaar_number: '123456789098',
    pan_card: '1708768015034-pan.jpeg',
    pan_card_number: 'qwerty1111',
    nominee_name: 'Company',
    nominee_phone: '1111111111',
    bank_name: 'Company',
    branch: 'Company',
    account_holder_name: 'Company',
    bank_account: '11111111111',
    ifsc: 'company',
    created_by_id: userId,
    company_name: companyName, // Will be updated after creation
    company_id: companyId, // Will be updated after creation
    company_address: 'hyd',
    role: roleId,
    role_name: 'company',
    user_auth_id: 'auth',
    status: 'VERIFIED',
  };
};

export const getDefaultAdmin = (
  companyId: string,
  companyName: string,
  roleId: string
) => {
  return {
    username: 'admin',
    phone: '1111111111',
    password: 'brandwar',
    img: '1709197660415-profile.png',
    address: 'hyd',
    email: 'noreply@brandwar.in',
    company_name: companyName,
    company_id: companyId,
    first_name: 'admin',
    last_name: 'admin',
    role: roleId,
    role_name: 'admin',
    status: 'VERIFIED',
  };
};

// utils.js
export function toTitleCase(text: any) {
  return text.replace(/\b\w/g, (match: any) => match.toUpperCase());
}

export const transformData = (data: any) => {
  const transformNode = (node: any) => {
    return {
      name: node.name,
      actor: node.title, // Use the appropriate field here
      children: (node.childs || []).map(transformNode),
      ...node, // Spread the rest of the node properties to be accessible in the custom node component
    };
  };

  return {
    name: data.name,
    actor: data.title, // Use the appropriate field here
    children: (data.childs || []).map(transformNode),
    ...data, // Spread the rest of the node properties to be accessible in the custom node component
  };
};
export const sendToReactNative = (data: any) => {
  const reactNativeWebView = (window as any).ReactNativeWebView;
  if (!reactNativeWebView) return;

  reactNativeWebView.postMessage(JSON.stringify({ data }));
};

export const createCroppedImage = async (imageSrc: string, croppedAreaPixels: any): Promise<Blob> => {
  const image = await loadImage(imageSrc);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  if (!ctx) throw new Error('Failed to get canvas context');

  // Set canvas size to cropped area dimensions
  canvas.width = croppedAreaPixels.width;
  canvas.height = croppedAreaPixels.height;

  // Draw the cropped image onto the canvas
  ctx.drawImage(
    image,
    croppedAreaPixels.x, // Start x-coordinate
    croppedAreaPixels.y, // Start y-coordinate
    croppedAreaPixels.width, // Crop width
    croppedAreaPixels.height, // Crop height
    0, // Draw x-coordinate
    0, // Draw y-coordinate
    croppedAreaPixels.width, // Draw width
    croppedAreaPixels.height // Draw height
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) resolve(blob);
      else reject(new Error('Failed to create cropped image blob'));
    }, 'image/jpeg');
  });
};

// Helper to load the image
const loadImage = (src: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous'; // Prevent CORS issues if the image is from an external source
    img.onload = () => resolve(img);
    img.onerror = (error) => reject(error);
    img.src = src;
  });

export const excludedLedgers = [
  'GST Payable',
  'GST Receivable',
  'TDS Receivable',
  'TDS Payable',
  'Cash in Hand',
  'Default Bank'
];